(function () {
    const WIDGET_SELECTOR = '#opus-stc-widget';
    const HIDE_ON_SCROLL_UP = false;
    const SCROLL_THRESHOLD = 5;
    const SCROLL_THROTTLE = 80;

    const ATC_SELECTORS = [
        '.section-main-product form[action*="/cart/add"] button[type="submit"][name="add"]',
        '.section-main-product form[action*="/cart/add"] button[type="submit"]',
        'product-form-component button[type="submit"][name="add"]',
        'product-form-component button[type="submit"]',
        'form[action*="/cart/add"] button[type="submit"][name="add"]',
        'form[action*="/cart/add"] button[type="submit"]',
        '.product-form__submit'
    ];

    // Get active display mode (always, starts_scroll, or past_add_button) from app settings                                                                                                                       
      function getAppDisplayMode() {                                                                                                                                                                                 
        try {                                                                                                                                                                                                        
          const settings = window.opusStickyATCSettings;                                                                                                                                                             
          if (!settings || !settings.configurations?.configuration) return 'past_add_button';                                                                                                                        
                                                                                                                                                                                                                     
          const isMobile = window.matchMedia('(max-width: 768px)').matches;                                                                                                                                          
          const configs = settings.configurations.configuration;                                                                                                                                                     
                                                                                                                                                                                                                     
          // Find the active configuration or fallback to the first active one                                                                                                                                       
          const activeConfig = configs.find((c) => c.status === 'active') || configs[0];                                                                                                                             
          if (!activeConfig) return 'past_add_button';                                                                                                                                                               
                                                                                                                                                                                                                     
          return isMobile                                                                                                                                                                                            
            ? activeConfig.mobileSettings?.whenShouldShowOnMobile                                                                                                                                                    
            : activeConfig.desktopSettings?.whenShouldShowOnDesktop;                                                                                                                                                 
        } catch (e) {                                                                                                                                                                                                
          return 'past_add_button';                                                                                                                                                                                  
        }                                                                                                                                                                                                            
      } 

    function throttle(fn, wait = 100) {
        let timeoutId = null;
        let lastRun = 0;

        return function () {
            const now = Date.now();
            const remaining = wait - (now - lastRun);

            if (remaining <= 0) {
                clearTimeout(timeoutId);
                timeoutId = null;
                lastRun = now;
                fn();
            } else if (!timeoutId) {
                timeoutId = setTimeout(() => {
                    timeoutId = null;
                    lastRun = Date.now();
                    fn();
                }, remaining);
            }
        };
    }

    function isUsable(el) {
        if (!el || el.closest(WIDGET_SELECTOR)) return false;

        const rect = el.getBoundingClientRect();

        if (rect.width <= 0 || rect.height <= 0) return false;

        const style = getComputedStyle(el);

        return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0'
        );
    }

    function getBuyButton() {
        for (const selector of ATC_SELECTORS) {
            for (const el of document.querySelectorAll(selector)) {
                if (isUsable(el)) return el;
            }
        }

        return null;
    }

    function getTopOffset() {
        const stickyHeader = document.querySelector(
            '.pageheader--sticky, .section-header--sticky, sticky-header'
        );

        if (!stickyHeader) return 0;

        return (
            document.querySelector('.section-header')?.offsetHeight ||
            stickyHeader.offsetHeight ||
            0
        );
    }

    let lastScrollY = Math.max(0, window.scrollY);
    let isScrollingDown = false;

    function handleScroll() {
        const displayMode = getAppDisplayMode();                                                                                                                                                                     
                                                                                                                                                                                                                     
        // If the setting is NOT 'past_add_button' (e.g. 'always' or 'starts_scroll'),                                                                                                                               
        // DO NOT override with sticky-atc--out! Let the app handle it natively.                                                                                                                                     
        if (displayMode !== 'past_add_button') {                                                                                                                                                                     
          document.body.classList.remove('sticky-atc--out');                                                                                                                                                         
          return;                                                                                                                                                                                                    
        }    
        
        const currentScrollY = Math.max(0, window.scrollY);
        const scrollDelta = currentScrollY - lastScrollY;

        if (Math.abs(scrollDelta) > SCROLL_THRESHOLD) {
            isScrollingDown = scrollDelta > 0;
            lastScrollY = currentScrollY;
        }

        const buyButton = getBuyButton();
        const topOffset = getTopOffset();

        let shouldShow = false;

        if (buyButton) {
            const rect = buyButton.getBoundingClientRect();

            shouldShow = rect.bottom <= topOffset;

            if (HIDE_ON_SCROLL_UP && !isScrollingDown) {
                shouldShow = false;
            }
        }

        document.body.classList.toggle(
            'sticky-atc--out',
            !shouldShow
        );

        document.body.classList.toggle(
            'scrolled-to-bottom',
            window.scrollY + window.innerHeight + 100 >
                document.body.scrollHeight
        );
    }

    const throttledOnScroll = throttle(
        handleScroll,
        SCROLL_THROTTLE
    );

    window.addEventListener(
        'scroll',
        throttledOnScroll,
        { passive: true }
    );

    window.addEventListener(
        'resize',
        throttledOnScroll,
        { passive: true }
    );

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            handleScroll,
            { once: true }
        );
    } else {
        handleScroll();
    }

    window.addEventListener(
        'load',
        handleScroll,
        { once: true }
    );

    const observer = new MutationObserver(throttledOnScroll);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();